import { useEffect, useState } from "react";
import { DELETE_COMPONENT, TOGGLE_DELETE_COMPONENT_DIALOG } from "../../../Context/Display/Components/ComponentsContextEvents";
import RemoveDialog from "../../Shared/Remove/RemoveDialog";
import useComponents from "../../../Hooks/Display/useComponents";
import { deleteComponent } from "../../../API/Display/Display";
import usePages, { useSelectedPage } from "../../../Hooks/Display/usePages";
import { getPageFromPages } from "../utils";
import { getComponentByProperty } from "./utils";

function DeleteComponentDialog() {

    const [{ components, deletedComponentIndex }, dispatchComponentEvent] = useComponents();
    const [, dispatchPageEvent] = usePages();

    const [component, setComponent] = useState({});

    const selectedPage = useSelectedPage();

    useEffect(() => {
        if (!deletedComponentIndex) {
            setComponent({});
            return;
        }
        const component = getComponentByProperty(components, "treeIndex", deletedComponentIndex);
        setComponent(component);
    }, [deletedComponentIndex])

    function toggleDeleteDialog() {
        dispatchComponentEvent({
            type: TOGGLE_DELETE_COMPONENT_DIALOG
        })
    }

    async function handleDelete() {
        await deleteComponent(selectedPage._id, component.id);
        dispatchComponentEvent({
            type: "DELETE_COMPONENT",
            payload: component.treeIndex
        })
        toggleDeleteDialog();
    }

    return (
        <RemoveDialog
            Title="Delete Component"
            toggleDeleteDialog={toggleDeleteDialog}
            message={`Are you sure you want to delete the ${component.componentName} component?`}
            onDelete={handleDelete}
            onCancel={toggleDeleteDialog}
            deleteButtonText="Delete" />
    )
}

export default DeleteComponentDialog;